class NewsletterForm extends HTMLElement {
    constructor() {
        super();

        const inFooter = this.dataset.footer == 'true';
        if (inFooter) window.addEventListener('resize', this.onWindowSizeChange.bind(this));

        this.lastGridColFooter = document.querySelector('#footer-last-grid-col');
        this.firstGridColFooter = document.querySelector('#footer-first-grid-col');

        this.mobile = null;
        if (inFooter) this.onWindowSizeChange();
    }

    onWindowSizeChange(evt = false) {
        const width = window.innerWidth;
        if (width < 750 && (this.mobile === null || this.mobile === false)) {
            this.mobile = true;
            this.firstGridColFooter.insertBefore(this, this.firstGridColFooter.firstChild);
        }

        if (width >= 750 && (this.mobile === null || this.mobile === true)) {
            this.mobile = false;
            this.lastGridColFooter.appendChild(this);
        }
    }
}

customElements.define('newsletter-form', NewsletterForm);
